<div class="w-100 bg-grey-200">
  <div>
    <div class="w-100 py-3 d-none d-lg-flex position-relative justify-content-center lazy-leaderboard-container">
      <div class="category-list-leaderboard-lg">
        <flo-lazy
          [componentConstructor]="AdComponent"
          [initialProps]="adConfigMap | mapGet: 'leaderboard-large'"
          [detectorHeight]="90"
        ></flo-lazy>
      </div>
    </div>
    <div class="ad-skin d-none d-xl-block">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="adConfigMap| mapGet: 'skin'"
      ></flo-lazy>
    </div>
  </div>
  <div
    class="w-100 py-3 d-none d-md-flex d-lg-none justify-content-center position-relative lazy-leaderboard-container"
  >
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="adConfigMap | mapGet: 'leaderboard-small'"
      [detectorHeight]="90"
    ></flo-lazy>
  </div>
  <main class="container container-fluid min-vh-100 px-0 pt-md-2">
    <div class="mt-md-3 row g-0">
      <div class="col-12 col-lg-8 mt-md-3 px-3 px-lg-4 border-lg-right">
        <div class="d-flex flex-row justify-content-between align-items-center mx-xl-2">
          <h1 class="h3 mb-0 text-capitalize" data-test="category-header">{{pageTitle}}</h1>
          <div class="d-none d-md-block search-desktop">
            <flo-search-input
              [placeholder]="searchPlaceholder"
              data-test="search-container-desktop"
              [formControl]="searchForm"
            ></flo-search-input>
          </div>
        </div>
        <div class="d-block d-md-none mt-3">
          <flo-search-input
            [placeholder]="searchPlaceholder"
            data-test="search-container-mobile"
            [formControl]="searchForm"
          ></flo-search-input>
        </div>
        <!-- Filters will go here, hidden for now -->
        <div class="d-none mb-4 mx-3 mx-md-4" style="height: 10px;" data-test="filter-list">Filters</div>
        <!-- End filters -->
        <div class="pb-5 pt-2 mx-xl-2">
          <ng-container *ngIf="categories && categories.length; else zeroState;">
            <ng-container [ngSwitch]="categories.length === 1">
              <div *ngSwitchCase="false" class="pt-2" data-test="grouped-view">
                <ng-container *ngTemplateOutlet="groupedView; context: categories"></ng-container>
              </div>
              <div *ngSwitchCase="true" class="pt-2" data-test="scrollable-view">
                <ng-container *ngTemplateOutlet="scrollableView; context: categories"></ng-container>
              </div>
            </ng-container>
          </ng-container>
          <ng-template #zeroState>
            <div class="text-center pt-5 mt-md-5" data-test="no-results">
              <ng-container *ngIf="(querySearch$ | async)?.hasSearch; else errorState">
                <div class="mt-md-5">
                  <flo-no-results data-test="no-results-component" [currentQueryText]="(querySearch$ | async)?.currentQuery"></flo-no-results>
                </div>
              </ng-container>
              <ng-template #errorState>
                <flo-error></flo-error>
              </ng-template>
            </div>
          </ng-template>
        </div>
      </div>
      <aside data-test="athletes-teams-rail" class="d-none d-lg-block col-lg-4 px-3 px-xl-4 pt-0">
        <div class="px-xl-2 stick-to-header">
          <div class="d-none d-lg-flex pt-3 justify-content-center lazy-flex-container">
            <flo-lazy
              [componentConstructor]="AdComponent"
              [initialProps]="adConfigMap | mapGet: 'rectangle-small'"
              [detectorHeight]="250"
            ></flo-lazy>
          </div>
        </div>
      </aside>
    </div>
  </main>
  <flo-adhesion-footer>
    <div class="adhesion-ad d-sm-none">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="adConfigMap | mapGet: 'adhesion'"
      ></flo-lazy>
    </div>
  </flo-adhesion-footer>
</div>
<!-- templates -->
<ng-template #groupedView>
  <div *ngFor="let cat of categories" class="mb-4">
    <div *ngIf="cat.header" class="border-bottom pt-3 pt-md-4 mx-2 mb-3">
      <a
        data-test="grouped-header"
        [routerLink]='[]'
        [queryParams]="cat.viewAll.visible ? cat.viewAll.params : {}"
        [ngStyle]="!cat.viewAll.visible && {'cursor': 'default'}"
        queryParamsHandling="merge"
      >
        <flo-slim-header
          [title]="cat.header"
          [cta]="cat.viewAll.visible ? cat.viewAll.text : undefined"
        ></flo-slim-header>
      </a>
    </div>
    <div class="grid-container px-0 pt-1 pt-md-2">
      <div *ngFor="let item of cat.items; trackBy: trackByCategoryId" class="grid-container-item grid-container-item__min-width mb-4">
        <a [routerLink]="item.href"
           data-test="category-list-item">
          <flo-avatar
            [id]="item.id"
            [image]="item.image"
            [primaryLabel]="item.primaryLabel"
            [selected]="false">
          </flo-avatar>
        </a>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #scrollableView>
  <div *ngFor="let cat of categories" class="mb-4">
    <div *ngIf="cat.header" class="border-bottom pt-3 pt-md-4 mx-2 mb-3">
      <a [routerLink]='[]' [queryParams]="cat.viewAll.params">
        <flo-slim-header
          [title]="cat.header"
          [cta]="cat.viewAll.visible ? cat.viewAll.text : undefined"
        ></flo-slim-header>
      </a>
    </div>
    <div class="grid-container px-0 pt-1 pt-md-2">
      <div *ngFor="let item of cat.items; trackBy: trackByCategoryId" class="grid-container-item grid-container-item__min-width mb-4">
        <a [routerLink]="item.href"
           data-test="category-list-item">
          <flo-avatar
            [id]="item.id"
            [image]="item.image"
            [primaryLabel]="item.primaryLabel"
            [selected]="false">
          </flo-avatar>
        </a>
      </div>
    </div>
  </div>
  <div floElementIsVisible (elementIsVisible)="showMoreCategories.emit()"></div>
</ng-template>
